import { createSlice } from "@reduxjs/toolkit";
import { getActivities } from "./activity.action";
import { IActivityState } from "./activity.interface";

const initialState: IActivityState = {
  activities: [],
  isGetActivitiesLoading: false,
  getActivitiesError: "",
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getActivities.pending, (state) => {
      state.isGetActivitiesLoading = true;
    });
    builder.addCase(getActivities.fulfilled, (state, action) => {
      state.isGetActivitiesLoading = false;
      state.activities = action.payload;
    });
    builder.addCase(getActivities.rejected, (state, action) => {
      state.isGetActivitiesLoading = false;
      state.activities = [];
      state.getActivitiesError = action.payload;
    });
  },
});

export default activitySlice.reducer;
